module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration003.a421a9e3.webp";